import { Comparable } from "@siteimprove/alfa-comparable";
import { Unit } from "../../unit/index.js";
import { Numeric } from "./numeric.js";
/**
 * @public
 */
export var Dimension;
(function (Dimension) {
    /**
     * Dimensions that are the result of a calculation.
     */
    class Calculated extends Numeric.Calculated {
        constructor(math, type) {
            super(math, type);
        }
        hasCalculation() {
            return true;
        }
        equals(value) {
            return value instanceof Calculated && super.equals(value);
        }
    }
    Dimension.Calculated = Calculated;
    /**
     * Dimensions that are a fixed (not calculated) value.
     */
    class Fixed extends Numeric.Fixed {
        _unit;
        constructor(value, unit, type) {
            super(value, type);
            this._unit = unit;
        }
        get unit() {
            return this._unit;
        }
        hasCalculation() {
            return false;
        }
        /**
         * {@link https://drafts.csswg.org/css-values/#canonical-unit}
         */
        get canonicalUnit() {
            // The this.type test does not correctly narrow T, so we need to force typing.
            return (this.type === "angle" ? Unit.Angle.Canonical : Unit.Length.Canonical);
        }
        equals(value) {
            return (value instanceof Fixed &&
                super.equals(value) &&
                value._unit === this._unit);
        }
        compare(value) {
            const a = this.withUnit(this.canonicalUnit);
            const b = value.withUnit(value.canonicalUnit);
            return Comparable.compareNumber(a.value, b.value);
        }
        hash(hash) {
            super.hash(hash);
            hash.writeString(this._unit);
        }
        toJSON() {
            return { ...super.toJSON(), unit: this._unit };
        }
        toString() {
            return `${this._value}${this._unit}`;
        }
    }
    Dimension.Fixed = Fixed;
    function isCalculated(value) {
        return value instanceof Calculated;
    }
    Dimension.isCalculated = isCalculated;
    function isFixed(value) {
        return value instanceof Fixed;
    }
    Dimension.isFixed = isFixed;
    function isDimension(value) {
        return value instanceof Calculated || value instanceof Fixed;
    }
    Dimension.isDimension = isDimension;
})(Dimension || (Dimension = {}));
//# sourceMappingURL=dimension.js.map